import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { useAssistantUnread } from "../../context/AssistantUnreadContext";
import { buildAssistantReturnPath } from "../../utils/assistantNavigation";

const GUEST_ASSISTANT_ROUTES = new Set([
  "/events/search",
  "/events/map_search",
  "/clubs",
]);
const EVENT_CATALOG_ROUTES = new Set([
  "/events/search",
  "/events/map_search",
]);

function formatUnreadLabel(count) {
  const unread = Math.max(0, Math.floor(Number(count) || 0));
  if (!unread) return "";
  if (unread > 99) return "99+";
  return String(unread);
}

export default function GuestAssistantLauncher({ isGuest = false }) {
  const { t } = useTranslation("menu");
  const location = useLocation();
  const navigate = useNavigate();
  const { unreadCount } = useAssistantUnread();
  const [eventListOverlayOpen, setEventListOverlayOpen] = useState(false);

  useEffect(() => {
    setEventListOverlayOpen(false);
    if (
      !EVENT_CATALOG_ROUTES.has(location.pathname) ||
      typeof window === "undefined"
    ) {
      return undefined;
    }

    const handleEventOverlayToggle = (event) => {
      setEventListOverlayOpen(Boolean(event?.detail?.isOpen));
    };
    window.addEventListener("vg-events-modal-toggle", handleEventOverlayToggle);
    return () => {
      window.removeEventListener("vg-events-modal-toggle", handleEventOverlayToggle);
    };
  }, [location.pathname]);

  if (
    !isGuest ||
    !GUEST_ASSISTANT_ROUTES.has(location.pathname) ||
    eventListOverlayOpen
  ) {
    return null;
  }

  const unreadLabel = formatUnreadLabel(unreadCount);

  return (
    <button
      type="button"
      onClick={() =>
        navigate("/assistant/core", {
          state: { assistantReturnTo: buildAssistantReturnPath(location) },
        })
      }
      aria-label={t("main.menu_layout.cards.assistant_title", {
        defaultValue: "AI assistant",
      })}
      className="fixed bottom-[max(env(safe-area-inset-bottom,0px),22px)] right-[var(--vg-page-gutter)] z-[1000] flex h-[58px] w-[58px] items-center justify-center rounded-full border border-white/50 bg-[linear-gradient(145deg,#6D95FF_0%,#416FD9_100%)] text-white shadow-[0_12px_26px_rgba(20,48,118,0.4),inset_0_1px_0_rgba(255,255,255,0.38)] transition hover:brightness-110 active:scale-[0.96] focus:outline-none focus-visible:ring-2 focus-visible:ring-white/90 lg:bottom-8"
    >
      <img src="/assets/menu/UI/chat.svg" alt="" className="h-5 w-5 object-contain" />
      {unreadLabel ? (
        <span className="absolute -right-1 -top-1 inline-flex h-[19px] min-w-[19px] items-center justify-center rounded-full bg-white px-[5px] text-[10px] font-extrabold leading-none text-[#3E6FFB] shadow-[0_0_8px_rgba(255,255,255,0.5)]">
          {unreadLabel}
        </span>
      ) : null}
    </button>
  );
}
